import { chooseLander, isDefaultExperimentRoute, previewVariant, reportAssignment, sendAssignedEvent, type ExperimentAssignment, type LanderChoice } from './experiments/assignment';
import { ACTIVE_EXPERIMENT, DEFAULT_LANDER_ID, LANDERS, PREVIEW_CHALLENGER_ID } from './experiments/definition';
import { setExperimentAssignment } from './experiments/runtime';
import { config } from './config';
import { measurementIsTest } from './measurement/environment';
import './styles/global.scss';

const bootstrap = import('./bootstrap');
function previewChoice(search: string): LanderChoice {
  const requested = new URLSearchParams(search).get('lander');
  const landerId = requested && Object.hasOwn(LANDERS, requested) ? requested
    : previewVariant(search) === 'experimental' ? PREVIEW_CHALLENGER_ID : DEFAULT_LANDER_ID;
  return {experimentId: null, arm: 'control', landerId, controlLanderId: DEFAULT_LANDER_ID, challengerLanderId: null};
}
function whenVisible(): Promise<void> {
  if (document.visibilityState === 'visible') return Promise.resolve();
  return new Promise(resolve => {
    const visible = () => { if (document.visibilityState === 'visible') { document.removeEventListener('visibilitychange', visible); resolve(); } };
    document.addEventListener('visibilitychange', visible);
  });
}
// Background and prerendered tabs render immediately but only count once someone sees them.
async function report(choice: LanderChoice, assignment: ExperimentAssignment) {
  await whenVisible();
  // Navigation while a background tab waits must not enroll a named route.
  if (!isDefaultExperimentRoute(window.location)) return;
  const server = await reportAssignment(config.apiBaseUrl, choice);
  if (!server) return;
  assignment.runId = server.runId; assignment.token = server.token;
  if (assignment.loadFailed) sendAssignedEvent(config.apiBaseUrl, server.token, 'load_failed');
  return server;
}
async function start() {
  if (!isDefaultExperimentRoute(window.location)) {
    const app = await bootstrap;
    app.mountApp(await app.namedRouteHero(location.hash));
    return;
  }
  const choice = measurementIsTest ? previewChoice(location.search) : chooseLander(ACTIVE_EXPERIMENT, DEFAULT_LANDER_ID);
  const assignment: ExperimentAssignment = {
    experimentId: choice.experimentId ?? '',
    variant: choice.arm === 'challenger' ? 'experimental' : 'control',
    preview: measurementIsTest, loadFailed: false, landerId: choice.landerId, renderedLanderId: choice.landerId,
  };
  let hero;
  try { hero = await LANDERS[choice.landerId]!(); }
  catch {
    assignment.loadFailed = true;
    assignment.renderedLanderId = choice.controlLanderId;
    try { hero = await LANDERS[choice.controlLanderId]!(); }
    catch { assignment.renderedLanderId = DEFAULT_LANDER_ID; hero = undefined; }
  }
  if (!measurementIsTest) assignment.reported = report(choice, assignment);
  setExperimentAssignment(assignment);
  (await bootstrap).mountApp(hero);
}
void start();
